<template lang="pug">
div
  .empty.my-2(v-if="!usuarios.length")
    .empty-icon
      i.fa.fa-users.fa-5x
    .empty-subtitle Nenhum usuário encontrado
  table.table.table-responsive.table-striped.table.table-sm(v-else)
    thead
      tr
        th {{ 'usuario.login' | tModel }}
        th {{ 'usuario.nome' | tModel }}
        th {{ 'usuario.email' | tModel }}
        th {{ 'usuario.validado_por' | tModel }}
    tbody
      tr(v-for="usuario in usuarios")
        td {{ usuario.login | cpfCnpj }}
        td {{ usuario.nome }}
        td {{ usuario.email }}
        td {{ usuario | enums('usuario.validado_por') }}
</template>

<script>
import { deepKey } from 'paliari-js-utils'
import { vuexDefaultMapping } from '@/mixins/show'

export default {
  vuex: { cadastros: vuexDefaultMapping },
  computed: {
    usuarios() {
      return deepKey(this, 'current.usuarios_ativos') || []
    },
  },
}
</script>
